var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wizard-progress-bar" },
    [
      _vm._l(_vm.steps, function(step, index) {
        return [
          _c(
            "div",
            {
              key: "step-" + index,
              staticClass: "wizard-step",
              class: {
                "wizard-step--current": _vm.currentStep === index + 1,
                "wizard-step--active": _vm.currentStep > index + 1,
                "wizard-step--inactive": _vm.currentStep < index + 1,
                "wizard-step--clickable": _vm.canClickStep(index + 1)
              },
              on: {
                click: function($event) {
                  return _vm.onStepClick(index + 1)
                }
              }
            },
            [
              _c("div", { staticClass: "wizard-step__indicator" }, [
                _c("span", [_vm._v(_vm._s(index + 1))])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "wizard-step__label" }, [
                _vm._v(_vm._s(step))
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "wizard-separator",
            class: { "last-separator": index === _vm.steps.length - 1 }
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }